import React from 'react';

import isEqual from 'lodash/isEqual';

import { siteIds } from '../../../constants';
import { siteId, brandSite } from '../../../sites';

import ViinimaaTitle from './viinimaa';
import KoskenkorvaTitle from './koskenkorva';
import PhilipsonSoderbergTitle from './philipson-soderberg';

function Title(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaTitle {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaTitle {...props} />;
  }
  if (isEqual(siteId, siteIds.Koskenkorva)) {
    return <KoskenkorvaTitle {...props} />;
  }
  if (isEqual(siteId, siteIds.PhilipsonSoderberg)) {
    return <PhilipsonSoderbergTitle {...props} />;
  }
  if (brandSite) {
    return <ViinimaaTitle {...props} />;
  }

  return null;
}

export default Title;
